
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PFAddressService from 'pf-address-service';

class StreetField extends PureComponent {
  render() {
    const {
      className,
      errorMsg,
      labelText,
      labelClassName,
      htmlFor,
      inputProps,
      smartystreetsconfig,
      renderInputComponent
    } = this.props;
    const { onSuggestionSelected, onBlurCallback, onFocusCallback } = inputProps;

    const wrapperClasses = classNames('txt-field ', className, {
      'txt-field--disabled': this.props.disabled
    });

    return <div className={wrapperClasses}>
      <label htmlFor={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
        {labelText}
      </label>
      <PFAddressService
        inputprops={inputProps}
        smartystreetsconfig={smartystreetsconfig}
        renderInputComponent={renderInputComponent}
        onBlurCallback={onBlurCallback}
        onFocusCallback={onFocusCallback}
        onSuggestionSelected={onSuggestionSelected}
      />
      { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
    </div>;
  }
}

export default StreetField;

